import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconLogo, IconContainer } from '../../../Icon/index.js';
const LeftBar = () => (_jsx(IconContainer, { ariaLabel: "AstrumU Logo", style: { width: 90, height: 37 }, children: _jsx(IconLogo.LogoAstrumuSecondary, {}) }));
export default LeftBar;
//# sourceMappingURL=index.js.map